import defaultApi from '../../api/defaultApi';

/**
 * Alertas en linea del usuario de la sesion (Bloque C).
 *
 * Usa defaultApi y no un axios propio: ese interceptor lee el JWT de
 * localStorage EN CADA request. Los servicios mas viejos del proyecto capturan
 * el token una sola vez, al importar el modulo, y si el usuario se loguea
 * despues de esa carga se quedan con el token vacio.
 */
export class AlertaService {

    /** Lo que muestra la campanita: dos numeros y nada mas. */
    async contador() {
        const res = await defaultApi.get('/alertas/contador');
        return res.data;
    }

    /**
     * Las alertas del usuario.
     * @param {boolean} soloPendientes solo las no leidas
     * @param {number}  limite         cuantas traer (el backend acota a 200)
     */
    async misAlertas(soloPendientes = false, limite = 50) {
        const res = await defaultApi.get('/alertas/mis-alertas', {
            params: { soloPendientes, limite }
        });
        return res.data;
    }

    async marcarLeida(id) {
        const res = await defaultApi.post(`/alertas/${id}/leida`);
        return res.data;
    }

    async marcarTodasLeidas() {
        const res = await defaultApi.post('/alertas/leer-todas');
        return res.data;
    }

    async marcarRevisada(id) {
        const res = await defaultApi.post(`/alertas/${id}/revisada`);
        return res.data;
    }

    // ---- Administracion de suscripciones (Bloque E) ----

    async listarSuscripciones() {
        const res = await defaultApi.get('/alertas/suscripciones');
        return res.data;
    }

    async catalogosSuscripciones() {
        const res = await defaultApi.get('/alertas/suscripciones/catalogos');
        return res.data;
    }

    async guardarSuscripcion(datos) {
        const res = await defaultApi.post('/alertas/suscripciones', datos);
        return res.data;
    }

    async desactivarSuscripcion(id) {
        const res = await defaultApi.post(`/alertas/suscripciones/${id}/desactivar`);
        return res.data;
    }

    // ---- Consulta de alertas ----

    /**
     * Busca alertas dentro del alcance del usuario.
     *
     * El backend exige un rango de fechas o un codigo (placa, contenedor,
     * booking, candado). Si no viene ninguno devuelve ok=false con el motivo:
     * no es un error, es el control que evita recorrer 4 millones de filas.
     */
    async consultar(filtros, pagina = 0, tamano = 50) {
        const res = await defaultApi.post('/alertas/consulta', { filtros, pagina, tamano });
        return res.data;
    }

    /**
     * Las mismas alertas que consultar(), agrupadas por viaje (placa + candado
     * + booking + contenedor), con cuantas le faltan ver al usuario.
     */
    async consultarPorViaje(filtros, pagina = 0, tamano = 20) {
        const res = await defaultApi.post('/alertas/consulta/viajes', { filtros, pagina, tamano });
        return res.data;
    }

    /**
     * Tablero de operacion de seguridad: la consulta por viaje con el semaforo
     * de cada viaje (nivel, motivos) y los parametros vigentes. Los rojos primero.
     */
    async consultarSeguridad(filtros, pagina = 0, tamano = 20) {
        const res = await defaultApi.post('/alertas/seguridad/viajes', { filtros, pagina, tamano });
        return res.data;
    }

    /** Un viaje para el mapa: eventos con su clase, grupos de paradas y recorrido. */
    async viajeSeguridad(viajeId) {
        const res = await defaultApi.get(`/alertas/seguridad/viaje/${viajeId}`);
        return res.data;
    }

    /**
     * Registra que el usuario abrio una o varias alertas: las marca leidas y
     * deja la fila de auditoria (origen, pantalla, IP y GPS). La IP la pone el
     * servidor. Devuelve por alerta fechaLeida, vistas y ultimaVista.
     */
    async registrarVista(datos) {
        const res = await defaultApi.post('/alertas/vista', datos);
        return res.data;
    }

    /** Cada apertura de una alerta por el usuario de la sesion (solo las propias). */
    async historialVista(monitoreoDetId) {
        const res = await defaultApi.get('/alertas/vista/historial', { params: { monitoreoDetId } });
        return res.data;
    }

    /**
     * Auditoria de lectura de todos los usuarios (administrador y supervisor de
     * consola). Filtros: desde, hasta (hasta 31 dias), usuario, pantalla, texto.
     */
    async auditoria(filtros) {
        const res = await defaultApi.post('/alertas/auditoria', filtros);
        return res.data;
    }

    /** Resumen del tablero: por dia, por tipo, por transportista y los KPIs. */
    async tablero(dias = 30) {
        const res = await defaultApi.get('/alertas/tablero', { params: { dias } });
        return res.data;
    }

    /**
     * El corte por transportista del tablero.
     *
     * Va en su propia llamada porque es el unico bloque caro: el backend lo
     * acota a 30 dias aunque se le pida mas.
     */
    async tableroTransportistas(dias = 30) {
        const res = await defaultApi.get('/alertas/tablero/transportistas', { params: { dias } });
        return res.data;
    }

    /** Valores para los desplegables, y el alcance del usuario en palabras. */
    async consultaCatalogos() {
        const res = await defaultApi.get('/alertas/consulta/catalogos');
        return res.data;
    }

    /** Estado de la transicion del correo a la aplicacion (Bloque F). */
    async saludSuscripciones() {
        const res = await defaultApi.get('/alertas/suscripciones/salud');
        return res.data;
    }
}

export default new AlertaService();
